import {removeUndefined} from "../../util/util";
import {otsBaseApi} from "../ots-api";

export type TransportGaugeQuantityRequest = {
  transportId: string;
  database?: string;
};

/** Optional creation window (epoch millis) and page; the server defaults to the newest 50 (page 0). */
export type TransportGaugeQuantityAuditsRequest = TransportGaugeQuantityRequest & {
  fromDttm?: number;
  toDttm?: number;
  page?: number;
  size?: number;
};

/**
 * Gauge quantity audits and previews for one transport. Responses are typed by their consumer
 * (`GaugeQuantityAudit` / `GaugeQuantityResult` in ots-ui-tw), which reads them defensively.
 */
export const gaugeQuantityApi = otsBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransportGaugeQuantityAudits: builder.query<unknown[], TransportGaugeQuantityAuditsRequest>({
      query: ({transportId, database, fromDttm, toDttm, page, size}) => ({
        url: `/transports/${encodeURIComponent(transportId)}/gauge-quantity/audits`,
        method: "GET",
        params: removeUndefined({tenantCode: database, fromDttm, toDttm, page, size}),
      }),
    }),
    previewTransportGaugeQuantity: builder.mutation<unknown, TransportGaugeQuantityRequest>({
      query: ({transportId, database}) => ({
        url: `/transports/${encodeURIComponent(transportId)}/gauge-quantity/preview`,
        method: "POST",
        params: removeUndefined({tenantCode: database}),
      }),
    }),
  }),
});

export const {useGetTransportGaugeQuantityAuditsQuery, usePreviewTransportGaugeQuantityMutation} = gaugeQuantityApi;
